/**
 * Browser entry. Built to dist/touchpoints.js and loaded by the website.
 *
 * Usage on the host page (after the site's consent logic decided to load it):
 *
 *   <script src="https://.../touchpoints.js" defer></script>
 *
 * The bundle records the current visit immediately and exposes
 * window.schulteTouchpoints with read() and clear() for the host page.
 */
import { clear, read, record, type TouchpointRecord } from "./tracker.js";

export interface SchulteTouchpointsApi {
  read(): TouchpointRecord | null;
  clear(): void;
}

declare global {
  interface Window {
    schulteTouchpoints?: SchulteTouchpointsApi;
  }
}

function storage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

const api: SchulteTouchpointsApi = {
  read: () => {
    const s = storage();
    return s ? read(s) : null;
  },
  clear: () => {
    const s = storage();
    if (s) clear(s);
  },
};

const s = storage();
if (s) {
  record(s, { url: window.location.href, referrer: document.referrer, now: new Date() });
}

window.schulteTouchpoints = api;

export default api;
